<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            @if (showDocumentButton) {
                <button
                    type="button"
                    (click)="saveDocuments()"
                    class="btn btn-cerrix"
                    [disabled]="
                        !permissions.documentPermissions.canAddDocument || isSavingDocuments
                    "
                >
                    @if (isSavingDocuments) {
                        <i class="fas fa-circle-notch fa-spin ms-2"></i>
                    } @else {
                        <i class="fas fa-save"></i>
                    }
                    <span class="d-none d-lg-inline">Save documents</span>
                </button>
            }

            @if (showAssessmentDocumentButton) {
                <button
                    type="button"
                    (click)="saveAssessmentDocuments()"
                    class="btn btn-cerrix"
                    [disabled]="
                        !permissions.documentPermissions.canAddDocument ||
                        isSavingAssessmentDocuments
                    "
                >
                    @if (isSavingAssessmentDocuments) {
                        <i class="fas fa-circle-notch fa-spin ms-2"></i>
                    } @else {
                        <i class="fas fa-save"></i>
                    }
                    <span class="d-none d-lg-inline">Save documents</span>
                </button>
            }

            @if (!isStoredAssessment && requestModel) {
                @if (requestModel.organizationID) {
                    <span class="sub-message">
                        Save review configuration to start assessment.
                    </span>
                } @else {
                    <span class="sub-message"> Organization is required to start assessment. </span>
                }
            }
        </div>
    </div>

    @if (permissions) {
        <div menuSystem [cerrixTab]="tab" (changeEvent)="onMenuItemClick($event)">
            <div
                [attr.name]="'Business Assessment'"
                menuicon="fad fa-object-group"
                menusystemsubmenu
            >
                @if (requestModel) {
                    <div
                        menuItemId="assessment"
                        name="Assessment"
                        menuicon="fas fa-info-circle"
                        menusystemitem
                    >
                        <business-details [requestModel]="requestModel"></business-details>
                        @if (requestModel.organizationID) {
                            <business-review
                                [cerrixTab]="tab"
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-review>
                        }
                        @if (applicationPermissions.HasRiskAccess) {
                            <business-risks-widget
                                [businessDimensionId]="requestModel.businessID"
                                [orgId]="requestModel.organizationID"
                            >
                            </business-risks-widget>
                            <business-risks
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-risks>
                        }
                        @if (applicationPermissions.HasControlAccess) {
                            <business-controls
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-controls>
                        }
                        @if (useIncidents && applicationPermissions.HasEventAccess) {
                            <business-incidents
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-incidents>
                        }
                        @if (applicationPermissions.HasEventAccess) {
                            <business-events
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-events>
                        }
                        @if (applicationPermissions.HasMoiAccess) {
                            <business-mois
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-mois>
                        }
                        @if (applicationPermissions.HasKriAccess) {
                            <business-kris
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-kris>
                        }
                        @if (applicationPermissions.HasDataMangementAccess) {
                            <business-dataprocessing
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-dataprocessing>
                        }
                        @if (applicationPermissions.HasThirdPartyAccess) {
                            <business-thirdparties
                                [requestModel]="requestModel"
                                [permissionsModel]="permissions"
                            ></business-thirdparties>
                        }
                    </div>
                }
                @if (applicationPermissions.HasProcessDiagramAccess && requestModel.businessID) {
                    <div
                        name="Process Overview"
                        menuicon="fas fa-map"
                        [attr.menuItemId]="processSideMenuKey"
                        menusystemitem
                    >
                        <app-process-editor
                            [readOnly]="true"
                            [showFilter]="false"
                            [cerrixTab]="tab"
                            #processEditor
                        ></app-process-editor>
                    </div>
                }
                @if (isStoredAssessment) {
                    <div
                        menuItemId="menuLinks"
                        name="Links"
                        menuicon="fas fa-link"
                        menusystemsubmenu
                    >
                        @if (requestModel.businessID) {
                            <div
                                [attr.menuItemId]="documentsSideMenuKey"
                                name="Business Dimension Documents"
                                menuicon="far fa-file"
                                menusystemitem
                            >
                                <div>
                                    <business-documents
                                        [requestModel]="requestModel"
                                        [permissions]="permissions"
                                        [cerrixTab]="tab"
                                        #businessDocumentsComponent
                                    ></business-documents>
                                </div>
                            </div>
                        }
                        <div
                            [attr.menuItemId]="assessmentDocumentsSideMenuKey"
                            name="Assessment Documents"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            <div>
                                <business-assessment-documents
                                    [requestModel]="requestModel"
                                    [permissions]="permissions"
                                    [cerrixTab]="tab"
                                    #businessAssessmentDocumentsComponent
                                ></business-assessment-documents>
                            </div>
                        </div>
                        <div
                            name="Hyperlinks"
                            [attr.menuItemID]="hyperlinksSideMenuKey"
                            menuicon="fas fa-external-link-alt"
                            menusystemitem
                        >
                            <business-hyperlinks
                                [requestModel]="requestModel"
                                [permissions]="permissions"
                                [cerrixTab]="tab"
                                #businessHyperlinksComponent
                            ></business-hyperlinks>
                        </div>
                    </div>

                    <div
                        [attr.menuItemId]="historySideMenuKey"
                        name="History"
                        menuicon="fas fa-history"
                        menusystemitem
                    >
                        <app-history-overview
                            [historyDataService]="dataService"
                            [Id]="requestModel.businessAssessmentID"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    </div>

                    <div name="Options" menuicon="fas fa-check-double" menusystemitem>
                        <detail-options
                            moduleName="Business assessment"
                            objectName="business assessment"
                            customText="This is a permanent delete. No restore possible. Are you sure you want to continue?"
                            [allowDelete]="true"
                            (onDelete)="delete()"
                        >
                        </detail-options>
                    </div>
                }
            </div>
        </div>
    }
}
